import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import GUI from 'lil-gui'
//import typefaceFont from 'three/examples/fonts/Rimma_sans Bold_Regular.json' we will use another method for practise
import {FontLoader} from 'three/examples/jsm/loaders/FontLoader.js'
import {TextGeometry} from 'three/examples/jsm/geometries/TextGeometry.js'
import { OutlineEffect } from 'three/examples/jsm/effects/OutlineEffect.js'



/**
 * Debug
 */

const gui = new GUI(
    {
        width: 250,
        title: 'Colors'
    }
)
const debugObject = {}
debugObject.color1 = 0xbde0fe
debugObject.color2 = 0xedf2fb
debugObject.color3 = 0x9b5de5
debugObject.color4 = 0xbde0fe



// debugObject.color1 = 0xfcb1ff
// debugObject.color2 = 0xe0dd00
// debugObject.color3 = 0xf6b1ff
// debugObject.color4 = 0xfcfff4

// gui controls


window.addEventListener('keydown', (event) =>
    {
        if(event.key == 'h')
            gui.show(gui._hidden)
    })

// Gesture variables
let lastTapTime = 0;

// Add event listener for touch events to detect a double-tap
window.addEventListener('touchend', (event) => {
    const currentTime = new Date().getTime();
    const tapLength = currentTime - lastTapTime;

    if (tapLength < 300 && tapLength > 0) {
        // Double-tap detected
        gui.show(gui._hidden);
    }

    lastTapTime = currentTime;
});


// Canvas
const canvas = document.querySelector('canvas.webgl')



// Scene
const scene = new THREE.Scene()
scene.background= new THREE.Color(debugObject.color4)

//gui
gui
.addColor(debugObject, 'color4')
.onChange(()=>
{
    scene.background.set(debugObject.color4); 
})
.name('Background')


//Axes helper
// const axesHelper = new THREE.AxesHelper()
// scene.add(axesHelper)


//0xffafcc

// Create a toon material with the gradient map
const toonMaterial = new THREE.MeshToonMaterial({
    color: debugObject.color1
    
})

gui.addColor(debugObject, 'color1')
    .onChange(() =>
    {
        toonMaterial.color.set(debugObject.color1)
    }).name('Donut')



const toonMaterial2 = new THREE.MeshToonMaterial({
    color: 0xedf2fb
    
})
gui.addColor(debugObject,'color2')
.onChange(()=>{
    toonMaterial2.color.set(debugObject.color2)
})
.name ('Text')

toonMaterial.side = THREE.DoubleSide
toonMaterial2.side = THREE.DoubleSide


/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()
const matCapTexture = textureLoader.load('/textures/matcaps/8.png')
//const toonMaterial= new THREE.MeshToonMaterial({gradientMap: gradientTexture})






matCapTexture.coloSpace = THREE.SRGBColorSpace


/**
 * Fonts
 */
const fontLoader = new FontLoader()
fontLoader.load(
    '/fonts/Rimma_sans Bold_Regular.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Learning\nThreeJS',
            {
                font: font,
                
                size: 0.3,
                depth: 0.05,
                curveSegments: 4,
                bevelEnabled: true,
                bevelThickness: 0.03,
                bevelSize: 0.002,
                bevelOffset: 0,
                bevelSegments: 3

            }
        )
        // textGeometry.computeBoundingBox()
        
        
        // textGeometry.translate(
        //     -(textGeometry.boundingBox.max.x- 0.002)*0.5,
        //     -(textGeometry.boundingBox.max.y- 0.002)*0.5,
        //     -(textGeometry.boundingBox.max.z*0.5- 0.03)
        // )
        textGeometry.center()
       
        const text = new THREE.Mesh(textGeometry, toonMaterial2)
        scene.add(text)

        const donutGeometry = new THREE.TorusGeometry(0.3, 0.2, 20, 45)
       


        console.time('donuts')
        
       
        for (let i = 0; i <300; i++)
        {
            
            const donut = new THREE.Mesh(donutGeometry, toonMaterial)
            donut.position.x = (Math.random()-0.5)*10
            donut.position.y = (Math.random()-0.5)*10
            donut.position.z = (Math.random()-0.5)*10
            
            donut.rotation.x= Math.random()* Math.PI
            donut.rotation.y= Math.random()* Math.PI

            const scale = Math.random()
            donut.scale.set(scale, scale, scale)

            
            scene.add(donut)
        }
        console.timeEnd('donuts')


    }
    

)






/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})


/**
 * Light
 */

// const ambientLight = new THREE.AmbientLight(0xfbf8cc, 2)
// scene.add(ambientLight)
//9b5de5  pointLight.position.set(1,4, 7)
const pointLight = new THREE.PointLight(debugObject.color3, 1500)
pointLight.position.set(8,7, 7)
scene.add(pointLight)

gui
.addColor(debugObject, 'color3')
.onChange(()=>
    {
        pointLight.color.set(debugObject.color3)
    })
.name('Light')



/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 1
camera.position.y = 1
camera.position.z = 2
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true



/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

// Create OutlineEffect
const effect = new OutlineEffect(renderer, {
    defaultThickness: 0.002,
    defaultColor: [0, 0, 0], // Outline color (black)
    defaultAlpha: 1.0,
    defaultKeepAlive: true // Keep outline even if the mesh is removed
})





/**
 * Animate
 */
const clock = new THREE.Clock()


const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Rotate each donut slightly
    scene.traverse((child) => {
        if (child.isMesh && child.geometry.type === 'TorusGeometry') {
            child.rotation.x += 0.005; // Rotate around the x-axis
            child.rotation.y += 0.005; // Rotate around the y-axis
        }
    });

    // Update controls
    controls.update()

    // Render
    //renderer.render(scene, camera)

    // Render using OutlineEffect instead of the default renderer
    effect.render(scene, camera);

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}



tick()